export default "__VITE_ASSET__DAwyMXho__"